module.exports = __webpack_public_path__ + "static/img/14.5cab1d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/zh/14.png
// module id = D45U
// module chunks = 0